import React, { Component } from "react";

class Information extends Component {
  render() {
    return (
      <div className="col-md-6">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={0}
          data-smobile={35}
        />
        <div className="themesflat-headings style-2 clearfix">
          <h2 className="heading">KONTAKTI</h2>
          <div className="sep has-width w80 accent-bg clearfix" />
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={36}
          data-mobile={35}
          data-smobile={35}
        />
        <div className="themesflat-tabs style-1 w168 clearfix">
          <ul className="tab-title clearfix">
            <li className="item-title active">
              <span className="inner">URED</span>
            </li>
            <li className="item-title">
              <span className="inner">PRODAJA</span>
            </li>
            <li className="item-title">
              <span className="inner">HELPDESK</span>
            </li>
          </ul>
          <div className="tab-content-wrap clearfix">
            <div className="tab-content">
              <div className="item-content">
                <ul>
                  <li className="clearfix">
                    <h5 class="feautured-title-heading">Zagreb</h5>
                    <div className="inner">
                      <span className="fa fa-map-marker" />
                      <span className="text">
                        Ulica kneza Mislava 13, Zagreb
                      </span>
                    </div>
                  </li>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-phone" />
                      <span className="text">T: (+385) 91 649 0066</span>
                    </div>
                  </li>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-envelope" />
                      <span className="text">M: info@cityx.hr</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content">
              <div className="item-content">
                {/** */}
                <ul>
                  <h5 class="feautured-title-heading">CityX App</h5>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-phone" />
                      <span className="text">M: (+385) 91 3029 346</span>
                    </div>
                  </li>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-envelope" />
                      <span className="text">E: katarina@cityx.hr</span>
                    </div>
                  </li>
                </ul>
                <br />
                {/** */}
                <ul>
                  <h5 class="feautured-title-heading">Sportter</h5>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-phone" />
                      <span className="text">M: (+385) 99 8299 353</span>
                    </div>
                  </li>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-envelope" />
                      <span className="text">E: ante@cityx.hr</span>
                    </div>
                  </li>
                </ul>
                <br />
                {/** */}
                <ul>
                  <h5 class="feautured-title-heading">CityX Tour&#38;Pass</h5>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-phone" />
                      <span className="text">M: (+385) 91 5023 424</span>
                    </div>
                  </li>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-envelope" />
                      <span className="text">E: martina@cityx.hr</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content">
              <div className="item-content">
                <ul>
                  <li className="clearfix">
                    <div className="inner">
                      <span className="fa fa-envelope" />
                      <span className="text">E: helpdesk@cityx.hr</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={20}
          data-mobile={35}
          data-smobile={35}
        />
      </div>
    );
  }
}

export default Information;
